import React from 'react';
import { Helmet } from 'react-helmet-async';

const LocalSEO = () => {
  const locationKeywords = [
    // RONE Brand Keywords
    'RONE', 'RONE company', 'RONE northeast', 'RONE BTC', 'RONE Kokrajhar',
    'RONE IT solutions', 'RONE ERP systems', 'RONE software',
    
    // BTC Specific Keywords
    'IT company BTC', 'software company BTC', 'ERP systems BTC',
    'technology solutions BTC', 'digital transformation BTC',
    'custom software development BTC', 'web development BTC',
    'mobile app development BTC', 'e-governance solutions BTC',
    
    // Kokrajhar Specific Keywords
    'IT company Kokrajhar', 'software company Kokrajhar', 'ERP systems Kokrajhar',
    'school management software Kokrajhar', 'college management system Kokrajhar',
    'attendance management system Kokrajhar', 'cloud solutions Kokrajhar',
    'IT services Kokrajhar', 'software development Kokrajhar',
    'technology company Kokrajhar', 'digital solutions Kokrajhar',
    
    // Northeast India Keywords
    'best IT company Northeast India', 'top software company Northeast',
    'ERP systems Northeast India', 'AI technology Northeast',
    'facial recognition Northeast', 'RFID solutions Northeast',
    'educational technology Northeast', 'school software Northeast',
    'IT consulting Northeast India', 'technology solutions Northeast',
    
    // Service-Specific Local Keywords
    'ERP for schools BTC', 'student management system Kokrajhar',
    'attendance tracking Assam', 'facial recognition Bodoland',
    'RFID attendance BTC', 'smart classroom Northeast',
    'e-learning solutions Kokrajhar', 'digital education BTC',
    
    // Competition Keywords
    'better than Infosys Northeast', 'local alternative to TCS',
    'Northeast IT company vs multinational', 'local software development',
    'indigenous IT solutions Northeast', 'made in Northeast technology'
  ];

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": ["Organization", "LocalBusiness", "TechnologyCompany"],
    "@id": "https://rotsnortheast.com",
    "name": "RONE - Roots of Northeast",
    "alternateName": ["RONE", "Roots of Northeast", "Roots of Northeast"],
    "legalName": "Roots of Northeast (RONE)",
    "description": "#1 IT Company in BTC Kokrajhar and Northeast India. We are RONE - the leading provider of ERP systems, AI-powered attendance management, facial recognition, and RFID solutions.",
    "disambiguatingDescription": "RONE is the premier technology company serving BTC, Kokrajhar, and all of Northeast India with world-class ERP systems and AI solutions.",
    "slogan": "Northeast India's Premier IT Solutions Provider",
    "url": "https://rotsnortheast.com",
    "mainEntityOfPage": "https://rotsnortheast.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://rotsnortheast.com/new_logo.png",
      "width": "300",
      "height": "100"
    },
    "image": [
      "https://rotsnortheast.com/rone-office-kokrajhar.jpg",
      "https://rotsnortheast.com/rone-team-btc.jpg",
      "https://rotsnortheast.com/rone-erp-demo.jpg"
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Technology Innovation Hub, Kokrajhar",
      "addressLocality": "Kokrajhar",
      "addressRegion": "BTC, Assam",
      "postalCode": "783370",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "26.4019",
      "longitude": "90.2715"
    },
    "hasMap": "https://goo.gl/maps/rone-kokrajhar-btc",
    "areaServed": [
      {
        "@type": "AdministrativeArea",
        "name": "Bodoland Territorial Council",
        "alternateName": "BTC"
      },
      {
        "@type": "City",
        "name": "Kokrajhar",
        "sameAs": "https://en.wikipedia.org/wiki/Kokrajhar"
      },
      {
        "@type": "State", 
        "name": "Assam"
      },
      {
        "@type": "Country",
        "name": "Northeast India"
      }
    ],
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "26.4019",
        "longitude": "90.2715"
      },
      "geoRadius": "500000"
    },
    "telephone": "+91-91016-33479",
    "email": "info@rotsnortheast.com",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+91-91016-33479",
        "contactType": "customer service",
        "areaServed": ["BTC", "Kokrajhar", "Assam", "Northeast India"],
        "availableLanguage": ["English", "Hindi", "Assamese", "Bodo"],
        "hoursAvailable": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        }
      }
    ],
    "openingHours": "Mo-Fr 09:00-18:00",
    "currenciesAccepted": "INR",
    "paymentAccepted": ["Cash", "Credit Card", "Bank Transfer", "UPI", "Digital Payment"],
    "priceRange": "$$",
    "foundingDate": "2019",
    "numberOfEmployees": {
      "@type": "QuantitativeValue",
      "value": "13"
    },
    "industry": "Information Technology",
    "naics": "541511",
    "isicV4": "6201",
    "knowsAbout": [
      "ERP Systems", "Educational Technology", "AI Attendance Management",
      "Facial Recognition Technology", "RFID Solutions", "Software Development",
      "Cloud Computing", "Digital Transformation", "School Management Systems",
      "Student Information Systems", "Web Development", "Mobile App Development"
    ],
    "keywords": locationKeywords.join(', '),
    "hasCredential": [
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "ISO 9001:2015 Certified"
      },
      {
        "@type": "EducationalOccupationalCredential", 
        "credentialCategory": "NASSCOM Member"
      }
    ],
    "award": [
      "Best IT Company Northeast India 2023",
      "Excellence in Educational Technology 2024",
      "Top Software Company BTC 2023",
      "Innovation Award Assam 2024"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "150",
      "bestRating": "5",
      "worstRating": "1"
    },
    "sameAs": [
      "https://www.linkedin.com/company/rone-rots-northeast",
      "https://twitter.com/rone_northeast", 
      "https://www.facebook.com/rone.northeast",
      "https://www.instagram.com/rone_northeast",
      "https://www.youtube.com/c/ronenortheast",
      "https://github.com/rone-northeast",
      "https://medium.com/@rone-northeast"
    ],
    "parentOrganization": {
      "@type": "Organization",
      "name": "RONE Group"
    },
    "brand": {
      "@type": "Brand",
      "name": "RONE",
      "logo": "https://rotsnortheast.com/new_logo.png"
    },
    "owns": [
      {
        "@type": "Product",
        "name": "RONE ERP Suite",
        "description": "Comprehensive ERP system for educational institutions"
      },
      {
        "@type": "Product", 
        "name": "RONE Attendance AI",
        "description": "AI-powered facial recognition attendance system"
      }
    ]
  };

  return (
    <Helmet>
      {/* Aggressive Local SEO Meta Tags */}
      <meta name="geo.region" content="IN-AS" />
      <meta name="geo.placename" content="Kokrajhar, BTC, Assam, Northeast India" />
      <meta name="geo.position" content="26.4019;90.2715" />
      <meta name="ICBM" content="26.4019, 90.2715" />
      <meta name="location" content="Kokrajhar, Bodoland Territorial Council, Assam, Northeast India" />
      <meta name="coverage" content="BTC, Kokrajhar, Assam, Meghalaya, Manipur, Tripura, Nagaland, Mizoram, Arunachal Pradesh" />
      <meta name="distribution" content="Northeast India, BTC, Kokrajhar" />
      
      {/* Brand Specific Tags */}
      <meta name="brand" content="RONE" />
      <meta name="company" content="RONE - Roots of Northeast" />
      <meta name="trademark" content="RONE®" />
      
      {/* Competition and Ranking Tags */}
      <meta name="ranking" content="#1 IT Company BTC Kokrajhar" />
      <meta name="local-business-type" content="IT Services, Software Development, ERP Systems" />
      <meta name="service-area" content="BTC, Kokrajhar, Assam, Northeast India" />
      
      {/* Enhanced Keywords Meta */}
      <meta name="keywords" content={locationKeywords.join(', ')} />
      
      {/* Local Business Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema, null, 2)}
      </script>
      
      {/* Additional Local Business Verification */}
      <meta name="google-site-verification" content="RONE-BTC-KOKRAJHAR-VERIFICATION" />
      <meta name="bing-site-verification" content="RONE-NORTHEAST-BING-VERIFICATION" />
      <meta name="yandex-verification" content="RONE-RUSSIA-VERIFICATION" />
      
      {/* Local Citations */}
      <link rel="canonical" href="https://rotsnortheast.com" />
      <link rel="alternate" hrefLang="en-IN" href="https://rotsnortheast.com" />
      <link rel="alternate" hrefLang="hi-IN" href="https://rotsnortheast.com/hi" />
      <link rel="alternate" hrefLang="as-IN" href="https://rotsnortheast.com/as" />
    </Helmet>
  );
};

export default LocalSEO;